import { navigate } from "raviger";
import { createNewOrder } from "./createNewOrder";
import { libTypes } from "@holta/lib";


export function createAndEditNewOrder(initialValues?: Partial<libTypes.Order>) {
    createNewOrder(initialValues);
    navigate("/orders/new");
}